import { h, Component } from 'preact';
import typographyStyle from '../style';
import style from './style';

const Text = ({
  children,
  color='gray',
  size='md',
  fontWeight='normal',
  textAlign='left',
  lineHeight=2,
  columnCount=1,
    columnGap=0,
}) => {
    const classes = [
      style.text,
      style[size],
      typographyStyle[color],
      typographyStyle[fontWeight],
      typographyStyle[textAlign]
    ];
    const inlineStyle = {
      lineHeight,
        columnCount,
        columnGap,
    }

		return (
      <span class={classes.join(' ')} style={inlineStyle}>
        {children}
      </span>
    )
}
export default Text;



// WEBPACK FOOTER //
// ./components/typography/text/Text.js